import { render } from "./TablaUsuarios.vue?vue&type=template&id=a5e929c4"
import script from "./TablaUsuarios.vue?vue&type=script&lang=js"
export * from "./TablaUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/vue/vue-crud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__